/** i18n key for time-of-day greeting on the student dashboard hero. */
export function getTimeOfDayGreetingKey(now: Date = new Date()): string {
  const hour = now.getHours();
  if (hour < 12) return 'dashboard.studentHome.greeting.goodMorning';
  if (hour < 17) return 'dashboard.studentHome.greeting.goodAfternoon';
  return 'dashboard.studentHome.greeting.goodEvening';
}
